/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// Custom Blog Recommend - ランダム選択（優先度2）→ 日付降順で表示
const initBlogRecommend = () => {
  document.querySelectorAll('.c-blog-recommend_wrapper[data-section-id]').forEach(wrapper => {
    const dataScript = wrapper.querySelector('script[data-blog-recommend-data]');
    const list = wrapper.querySelector('[data-blog-recommend-list]');
    if (!list) return;

    // data属性を持つカードだけを対象（スニペットの二重article対策）
    const cards = Array.from(list.querySelectorAll('.c-blog-recommend_item[data-article-id]'));
    if (cards.length === 0) return;

    let maxArticles = 6;
    if (dataScript?.textContent) {
      try {
        const data = JSON.parse(dataScript.textContent);
        maxArticles = Number(data?.maxArticles) || 6;
      } catch (_) {
        // ignore
      }
    }

    const priority1 = [];
    const priority2 = [];

    cards.forEach(card => {
      const id = card.dataset.articleId;
      if (!id) return;

      const publishedAt = Number(card.dataset.publishedAt || 0);
      const priority = card.dataset.priority;

      const data = { element: card, id, publishedAt };
      (priority === '1' ? priority1 : priority2).push(data);
    });

    priority1.sort((a, b) => b.publishedAt - a.publishedAt);

    // 優先度2は「ランダムに選んだあと日付順」なので、
    // 1) シャッフル 2) 先頭から必要数だけ確保 3) その確保分を日付降順にする
    const need = Math.max(0, maxArticles - priority1.length);
    const picked2 = priority2
      .slice()
      .sort(() => Math.random() - 0.5)
      .slice(0, need)
      .sort((a, b) => b.publishedAt - a.publishedAt);

    const finalList = [...priority1.slice(0, maxArticles), ...picked2].slice(0, maxArticles);
    if (finalList.length === 0) return;

    // 並び替え（appendChildで既存DOMを移動させるだけ）
    finalList.forEach(({ element }) => list.appendChild(element));
  });
};

// 初期化
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBlogRecommend);
} else {
  initBlogRecommend();
}

// Shopifyテーマエディタでの動的読み込み対応
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', initBlogRecommend);
}

//============================================================================
// Table of Contents - 目次自動生成
//============================================================================
const initTableOfContents = () => {
  const TOC_INSERT_SELECTOR = '#Toc .c-toc_container';
  const HEADING_SELECTOR =
    '.article__content h2,.article__content h3,.article__content h4,.article__content h5,.article__content h6';
  const LINK_CLASS_NAME = 'c-toc_link link--faded';
  const ID_NAME = 'heading';
  const tocInsertElement = document.querySelector(TOC_INSERT_SELECTOR);
  const headingElements = document.querySelectorAll(HEADING_SELECTOR);
  const layer = [];
  let id = 0;
  const uid = () => `${ID_NAME}${id++}`;
  let oldRank = -1;

  if (!tocInsertElement) return;

  // 見出し要素がない場合は目次を非表示にして終了
  if (headingElements.length === 0) {
    const tocElement = document.getElementById('Toc');
    if (tocElement) {
      tocElement.style.setProperty('display', 'none', 'important');
    }
    return;
  }

  try {
    const createLink = (el) => {
      let li = document.createElement('li');
      let a = document.createElement('a');
      el.id = el.id || uid();
      a.href = `#${el.id}`;
      a.innerText = el.innerText;
      a.className = LINK_CLASS_NAME;
      li.appendChild(a);
      return li;
    };

    const findParentElement = (layer, rank, diff) => {
      do {
        rank += diff;
        if (layer[rank]) return layer[rank];
      } while (0 < rank && rank < 7);
      return false;
    };

    const appendToc = (el, toc) => {
      el.appendChild(toc.cloneNode(true));
    };

    headingElements.forEach((el) => {
      let rank = Number(el.tagName.substring(1));
      let parent = findParentElement(layer, rank, -1);
      if (oldRank > rank) layer.length = rank + 1;
      if (!layer[rank]) {
        layer[rank] = document.createElement('ol');
        if (parent.lastChild) parent.lastChild.appendChild(layer[rank]);
      }
      layer[rank].appendChild(createLink(el));
      oldRank = rank;
    });

    if (layer.length) {
      const parentElement = findParentElement(layer, 0, 1);
      if (parentElement) {
        appendToc(tocInsertElement, parentElement);
      }
    }
  } catch (e) {
    //error
  }

  // .c-toc_containerに要素がない場合は目次全体を非表示にする
  if (tocInsertElement && tocInsertElement.children.length === 0) {
    const tocElement = document.getElementById('Toc');
    if (tocElement) {
      tocElement.style.setProperty('display', 'none', 'important');
    }
  }

  // 固定ナビの高さを考慮してスクロール遷移
  const articleLinks = document.querySelectorAll(`.${LINK_CLASS_NAME}`);
  articleLinks.forEach((el) => {
    el.addEventListener('click', (e) => {
      const targetEl = document.querySelector(el.hash);
      scrollTo(0, window.pageYOffset + targetEl.getBoundingClientRect().top - 100);
      e.preventDefault();
      e.stopPropagation();
    });
  });
};

// ページ内リンクで固定ヘッダーの高さを考慮
const initTocPageLinks = () => {
  var headerHeight = parseInt(
    getComputedStyle(document.documentElement).getPropertyValue('--header-height')
  );
  var pageLinksToc = document.querySelectorAll('a[href^="#"]');
  pageLinksToc.forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      var target = document.querySelector(link.getAttribute('href'));
      if (target) {
        var top = target.getBoundingClientRect().top + window.pageYOffset - 60 - headerHeight;
        window.scrollTo({
          top,
          behavior: 'smooth',
        });
      }
    });
  });
};

// 初期化
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initTableOfContents();
    initTocPageLinks();
  });
} else {
  initTableOfContents();
  initTocPageLinks();
}

// Shopifyテーマエディタでの動的読み込み対応
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    initTableOfContents();
    initTocPageLinks();
  });
}
